var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { AfterViewInit, ChangeDetectorRef, EventEmitter, OnInit } from '@angular/core';
import { FormBuilder } from '@angular/forms';
import { CommunicationService } from '../../../services/communication.service';
import { TranslateService } from '@ngx-translate/core';
import { PreferencesService } from '../../../services/preferences.service';
import { Router } from '@angular/router';
import { ListingsService } from '../../../services/listings.service';
import { FiltersCommercialComponent } from './filters-commercial.component';
import { Filters } from '../../../classes/user-preferences';
var FiltersCommercialMobileComponent = /** @class */ (function (_super) {
    __extends(FiltersCommercialMobileComponent, _super);
    function FiltersCommercialMobileComponent(preferencesService, communicationService, translateService, router, listingsService, fb, cd) {
        var _this = _super.call(this, preferencesService, communicationService, translateService, router, listingsService, fb, cd) || this;
        _this.preferencesService = preferencesService;
        _this.communicationService = communicationService;
        _this.translateService = translateService;
        _this.router = router;
        _this.listingsService = listingsService;
        _this.fb = fb;
        _this.cd = cd;
        _this.closed = new EventEmitter();
        _this.filtersForm.addControl('price', _this.fb.control({}));
        _this.filtersForm.addControl('searchInputText', _this.fb.control(''));
        // code below removes the unnecessary items from the array objects for mobile
        _this.sqftOptions.splice(0, 1);
        _this.storiesOptions.splice(0, 1);
        _this.unitsOptions.splice(0, 1);
        _this.totalAcresOptions.splice(0, 1);
        _this.parkingOptions.splice(0, 1);
        return _this;
    }
    FiltersCommercialMobileComponent.prototype.ngOnInit = function () {
        var _this = this;
        _super.prototype.ngOnInit.call(this);
        this.addSub(this.communicationService.searchResultsAvailable.subscribe(function (results) {
            _this.listingsAvailable = results;
            document.querySelector('app-drawer .drawer-sub-title-right').innerHTML = _this.translateService.instant('filters.n-results', { n: results });
        }));
        this.addSub(this.communicationService.searching.activeSearchText.subscribe(function (text) { return _this.placeholder = text; }));
    };
    FiltersCommercialMobileComponent.prototype.onSubmit = function () {
        this.closed.emit();
    };
    FiltersCommercialMobileComponent.prototype.onReset = function () {
        _super.prototype.onReset.call(this);
        this._resetForm();
        this.broadcastChangedFilters();
    };
    FiltersCommercialMobileComponent.prototype._resetForm = function () {
        _super.prototype._resetForm.call(this);
        // Reset price and/or price per square foot
        this.filtersForm.patchValue({
            price: {}
        });
        this.clearBusinessTypes();
        this.clearListingTypes();
    };
    FiltersCommercialMobileComponent.prototype.broadcastChangedFilters = function () {
        var value = Object.assign(new Filters(), this.filtersForm.value);
        if (this.isPricePerSqft) {
            value.pricePerSqFt.min = this.filtersForm.controls['price'].value.min;
            value.pricePerSqFt.max = this.filtersForm.controls['price'].value.max;
            value.price = {};
        }
        else {
            value.price.min = this.filtersForm.controls['price'].value.min;
            value.price.max = this.filtersForm.controls['price'].value.max;
            value.pricePerSqFt = {};
        }
        value.rentalsOnly = this.onlyRentals;
        this._preferencesService.updateFilters(value);
        this.communicationService.searchParametersChanged.next();
    };
    return FiltersCommercialMobileComponent;
}(FiltersCommercialComponent));
export { FiltersCommercialMobileComponent };
